import React from 'react'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
  Toast,
  ToastBody,
  ToastHeader
} from 'reactstrap'
import './ContactModal.scss'
import { AvForm, AvField } from 'availity-reactstrap-validation';
import FormGroup from 'reactstrap/es/FormGroup'

class ContactModal extends React.Component {
  state = {
    modal: false,
    email: '',
    name: '',
    message: '',
    sending: false,
    showToast: false,
    success: true,
  }
  
  handleChange = (e) => {
    const change = {}
    change[e.target.name] = e.target.value
    this.setState(change)
  }
  
  handleInvalidSubmit = (event, errors, values) => {
    this.setState({ errors, values })
  }
  
  toggle = () => {
    this.setState(prevState => ({ modal: !prevState.modal, showToast: false }))
  }
  
  showToast = (success = true) => {
    this.setState({ showToast: true })
    setTimeout(() => {
      this.setState({ success })
    }, 0)
  }
  
  closeToast = () => this.setState({ showToast: false, success: true })
  
  sendEmail = async () => {
    const { name, email, message } = this.state
    this.setState(prevState => ({sending: !prevState.sending }))
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      mode: 'same-origin',
      body: JSON.stringify({ name, email, message })
    }
    const response = await fetch('/contact', options)
    if (!response.ok) {
      this.setState(prevState => ({sending: !prevState.sending, modal: !prevState.modal }))
      this.showToast(false)
      return
    }
    const json = await response.json()
    this.setState(prevState => ({sending: !prevState.sending, modal: !prevState.modal, success: true }))
    if (json.error) {
      this.showToast(false)
    } else if (json.ok) {
      this.showToast()
    }
  }
  
  spinner = (
    <Spinner type="grow" color="light" size="sm"/>
  )
  
  toast = () => {
    const { success, showToast } = this.state
    const color = success ? 'success' : 'danger'
    const headingText = success ? 'Thank you!' : 'Oops something went wrong!'
    const bodyText = success ?
      "I'll be in touch" :
      `Please try again later. If problem persists email me at janehartenstein@gmail.com`
    return (
      <Toast isOpen={showToast}>
        <ToastHeader className="pb-2" toggle={this.closeToast}>
          {<h5 className={`mb-0 text-${color}`}>{ headingText }</h5>}
        </ToastHeader>
        <ToastBody className={`bg-${success ? 'success' : 'danger'}`}>
          <p className="text-center text-justify text-white-50">
            { bodyText }
          </p>
        </ToastBody>
      </Toast>
    )
  }
  
  render() {
    const { modal } = this.state
    return (
      <div className="ContactModal d-flex flex-column justify-content-center">
        {this.toast() }
        <Button
          color="primary"
          size="lg"
          onClick={this.toggle}
        >Contact Jane</Button>
        <Modal isOpen={ modal }
               toggle={ this.toggle }
               backdrop={ true }
        >
          <ModalHeader toggle={ this.toggle }>Contact Jane</ModalHeader>
          <ModalBody className="bg-light">
            <div >
              { this.state.errors && this.state.errors.length > 0 && <p className="alert-danger">Please correct errors first, then try again.</p>}
            </div>
            <AvForm id="contactForm" onValidSubmit={ this.sendEmail } onInvalidSubmit={ this.handleInvalidSubmit } >
              <AvField name="name" placeholder="Name" type="text"
                       onChange={ this.handleChange }
                       validate={{
                         required: { value: true, errorMessage: 'Please enter a name'},
                         pattern: { value: '^[A-Za-z  ]+$', errorMessage: 'Name should only have letters'},
                         minLength: { value: 5, errorMessage: 'Name should have at least 5 characters' },
                         maxLength: { value: 20, errorMessage: 'Name should have no more than 20 characters' },
                       }}
              />
              <AvField name="email" placeholder="Email" type="email"
                       onChange={ this.handleChange }
                       validate={{
                         required: {value: true, errorMessage: 'Email is required.' },
                         email: { value: true, errorMessage: 'That doesn\'t look like a valid email.'}
                       }}
              />
              <AvField name="message" placeholder="Message..." type="textarea"
                       onChange={ this.handleChange }
                       validate={{
                         required: { value: true, errorMessage: 'A message is required.'},
                         minLength: { value: 10, errorMessage: 'Message should have at least 10 characters.'}
                       }}
              />
              <FormGroup className="d-flex justify-content-end">
                  <Button className="mr-2" color="secondary" onClick={this.toggle }>Cancel</Button>
                  <Button
                    type="submit"
                    color="primary" form="contactForm">
                    { this.state.sending && this.spinner }
                    { this.state.sending ? 'Sending...' : 'Send Message'}
                  </Button>
              </FormGroup>
            </AvForm>
          </ModalBody>
        </Modal>
      </div>
    )
    
  }
}

export default ContactModal
